import "./Blog.module.css";
import Header from "@/reusable_sections/Header";
import Intro from "./sections/Intro";
import Articles from "./sections/Articles";
import Footer from "@/reusable_sections/Footer";
export default function BlogPage() {
  return <div>
      <Header />
      <Intro />
      <Articles />
      <Footer />
    </div>;
}